import { FETCH_START_CONTENT } from './constants'

export const fetchStartContent = {
  request: currentPhoneId => ({
    type: FETCH_START_CONTENT['REQUEST'],
    currentPhoneId
  }),
  success: (startContent, currentPhoneId) => ({
    type: FETCH_START_CONTENT['SUCCESS'],
    startContent,
    currentPhoneId
  })
}



// WEBPACK FOOTER //
// ./src/containers/GettingStarted/actions.js